<div class="login-content">
  <img src="./../../../assets/LogoSimSaveLight.svg" alt="Sim Save Logo" class="login-content-img">
  
  <div class="login-content-card">
    <h2 class="login-content-title">Entrar na plataforma</h2>
    <p class="login-content-textContent">Digite seu e-mail e senha abaixo para entrar na plataforma.</p>

    <form class="login-content-form-container">
      <mat-form-field class="mat-form-container">
        <input matInput placeholder="Nome" value="">
      </mat-form-field>
      <mat-form-field class="mat-form-container">
        <input matInput placeholder="Senha" value="">
      </mat-form-field>
    </form>

    <button mat-raised-button color="primary" class="login-content-btn">Entrar</button>
  </div>
</div>
